export * from './IconPressureStroked';
